import Repo from './Repo.js'

export default class ManufacturerRepository extends Repo {
  constructor () {
    super('manufacturers')
  }

  all (q) {
      return super.all(q)
  }

  store (data) {
      return super.store(data)
  }

  update (id, data) {
      return super.update(id, data)
  }

  get (id) {
      return super.get(id)
  }

  delete (id) {
      return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  getTransactions(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/warehouse-transactions', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
